export default __webpack_public_path__ + "static/g2one-9e5817b5779e87428141347d6c628f71.jpg";